const DRAFT_TOKEN_KEY = 'guest_send_draft_token';
const DRAFT_EMAIL_KEY = 'guest_send_draft_email';
const VERIFIED_EMAILS_KEY = 'guest_send_verified_emails';
const VERIFIED_HOURS = 24;

type VerifiedMap = Record<string, string>;

function readVerifiedMap(): VerifiedMap {
  try {
    const raw = sessionStorage.getItem(VERIFIED_EMAILS_KEY);
    return raw ? (JSON.parse(raw) as VerifiedMap) : {};
  } catch {
    return {};
  }
}

function writeVerifiedMap(map: VerifiedMap) {
  sessionStorage.setItem(VERIFIED_EMAILS_KEY, JSON.stringify(map));
}

export function getGuestSendDraftToken(): string | null {
  return sessionStorage.getItem(DRAFT_TOKEN_KEY);
}

export function getGuestSendDraftEmail(): string | null {
  return sessionStorage.getItem(DRAFT_EMAIL_KEY);
}

export function hasGuestDraftForEmail(email: string): boolean {
  const normalized = email.toLowerCase().trim();
  return (
    !!getGuestSendDraftToken() && getGuestSendDraftEmail() === normalized
  );
}

export function setGuestSendDraft(token: string, email: string) {
  sessionStorage.setItem(DRAFT_TOKEN_KEY, token);
  sessionStorage.setItem(DRAFT_EMAIL_KEY, email.toLowerCase());
}

export function clearGuestSendDraft() {
  sessionStorage.removeItem(DRAFT_TOKEN_KEY);
  sessionStorage.removeItem(DRAFT_EMAIL_KEY);
}

/** Only call after successful OTP confirm or verified direct send. */
export function markGuestEmailVerified(email: string) {
  const normalized = email.toLowerCase().trim();
  const map = readVerifiedMap();
  map[normalized] = new Date(
    Date.now() + VERIFIED_HOURS * 60 * 60 * 1000,
  ).toISOString();
  writeVerifiedMap(map);
}

export function isGuestEmailVerifiedLocally(email: string): boolean {
  const normalized = email.toLowerCase().trim();
  const map = readVerifiedMap();
  const expiresAt = map[normalized];
  if (!expiresAt) return false;
  return new Date(expiresAt).getTime() > Date.now();
}

export function guestUploadAuthHeaders(): Record<string, string> {
  const token = getGuestSendDraftToken();
  if (!token) return {};
  return {Authorization: `Bearer ${token}`};
}
